if(window.innerWidth < 960){
    let menuItems = document.querySelectorAll('.menu .nav-main-item')
    menuItems.forEach(function(item) {
        item.addEventListener('click',function(){
            let activeItem = document.querySelector('.nav-main-item.active')
            console.log(activeItem)
            this.classList.toggle('active')
            if(activeItem){
                activeItem.classList.remove('active')
            }
        })
    })
}

let menuEntry = document.getElementsByClassName('nav-main-link');
let firstEntry = menuEntry[0].innerHTML;
let secondEntry = menuEntry[1].innerHTML;
let thirdEntry = menuEntry[2].innerHTML;
let fourthEntry = menuEntry[3].innerHTML;

const firstArray = firstEntry.split(" ");
const secondArray = secondEntry.split(" ");
const thirdArray = thirdEntry.split(" ");
const fourthArray = fourthEntry.split(" ");

let firstFilter= firstArray.filter(Boolean);
let secondFilter= secondArray.filter(Boolean);
let thirdFilter= thirdArray.filter(Boolean);
let fourthFilter= fourthArray.filter(Boolean);

menuEntry[0].innerHTML = '<span class="nav-main-link__label">' + firstFilter[1] + '</span>' + firstFilter[2] + '<svg aria-hidden="true" focusable="false">' +
                            '<use xlink:href="#header_menu_chevron"/>' + '</svg>';
menuEntry[1].innerHTML = '<span class="nav-main-link__label">' + secondFilter[1] + " " + secondFilter[2] + " " + secondFilter[3] + " " + '</span>' + secondFilter[4] + " " + secondFilter[5] + " " + secondFilter[6] + '<svg aria-hidden="true" focusable="false">' +
                            '<use xlink:href="#header_menu_chevron"/>' + '</svg>';
menuEntry[2].innerHTML = '<span class="nav-main-link__label">' + thirdFilter[1] + " " + thirdFilter[2] + " " + thirdFilter[3] + " " + thirdFilter[4] + " " + '</span>' + thirdFilter[5] + " " + thirdFilter[6] + " " + thirdFilter[7] + '<svg aria-hidden="true" focusable="false">' +
                            '<use xlink:href="#header_menu_chevron"/>' + '</svg>';
menuEntry[3].innerHTML = '<span class="nav-main-link__label">' + fourthFilter[1] + '</span>' + fourthFilter[2] + '<svg aria-hidden="true" focusable="false">' +
                            '<use xlink:href="#header_menu_chevron"/>' + '</svg>';